import { Component, ViewEncapsulation, Input } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { UtilitiesService } from '@toro/common/shared/services/utilities.service';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { SettingsService } from '@toro/common/shared/services/settings/settings.service';
import { HomeStatus } from '@toro/common/shared/enum/home-status.enum';
import { RegistrationStep } from '../../components/registration-status-card/registration-status-card.component';
import { skip } from 'rxjs/operators';
import { AdvisorAction } from '@toro/common/shared/state-management/advisor/advisor.action';
import { TrackingActions } from '@toro/common/shared/state-management/tracking/tracking.action';
import { ActionEventsEnum } from '@toro/common/shared/enum/tracking/action-events.enum';
import { SantanderSuitabilityService } from '@toro/common/shared/services/santander-suitability/santander-suitability-service';
import { environment } from '@hub-workspace/apps/logged-home/src/environments/environment';
import { IDENTIFICADA_STEP, IDENTIFICADA_STEP_LABEL, IDENTIFICADA_TRACKING } from '../home-identificada.tracking';

@Component({
    selector: 'home-logged-user-registering',
    templateUrl: './home-logged-user-registering.component.html',
    styleUrls: ['./home-logged-user-registering.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [],
})
export class HomeLoggedUserRegisteringComponent {
    public isNewBrand: boolean = environment.isNewBrand

    @Input() public homeRole: HomeStatus;

    /* ENUM */
    // public userRoles = RolesUser;
    public homeStatus = HomeStatus;
    // public scenario: RegistrationStatus;
    // public scenarioOptions = RegistrationStatus;

    public registrationAppUrl: string;
    public hubUrl: string;
    public tooltips: { [prop: string]: string } = {};

    /* Observables */
    public authentication$: Observable<any>;
    public disposableSubscriptions: Subscription[] = [];

    /**
     * Card de status cadastro
     */
    public registrationStep: RegistrationStep = RegistrationStep.Registration;
    public estimatedTime?: string;
    public statusDescription?: string;
    public hasAdvisor: boolean;
    public trackingStep: string;
    public trackingLabel: string;
    public waitingDescription: string = `Enquanto isso, que tal conhecer ${ environment.isNewBrand ? "nossos cursos" : "alguns cursos da Toro" }?`;


    constructor(
        private store: Store<AppState>,
        private utilitiesService: UtilitiesService,
        private settingsService: SettingsService,
        private santanderSuitabilityService: SantanderSuitabilityService,
    ) {
        this.authentication$ = this.store.select((state) => state.authentication);

        // URL da página de cadastro
        this.registrationAppUrl = this.settingsService.getConfigurationKeyValue('rau');
        this.hubUrl = this.settingsService.getConfigurationKeyValue('hubUrl');
    }

    public ngOnInit() {
        if (this.homeRole === HomeStatus.RegisteredWithoutDocs) {
            this.registrationStep = RegistrationStep.Validating;
            this.estimatedTime = '1 dia útil';
            this.statusDescription = 'Validando dados.';
            this.trackingStep = IDENTIFICADA_STEP.dadosEmAnalise;
        } else if (this.homeRole === HomeStatus.RegisteredSendDocs) {
            this.registrationStep = RegistrationStep.Validating;
            this.estimatedTime = undefined;
            this.statusDescription = 'Aguardando documentos.';
            this.trackingStep = IDENTIFICADA_STEP.envioDocumentos;
        } else if (this.homeRole === HomeStatus.RegisteredDocsSended || this.homeRole === HomeStatus.RegisteredDocsSendedWithoutSuitability) {
            this.registrationStep = RegistrationStep.Validating;
            this.estimatedTime = '2 dias úteis';
            this.statusDescription = 'Validando documentos.';
            this.trackingStep = IDENTIFICADA_STEP.documentosEmAnalise;
        } else if (this.homeRole === HomeStatus.RegisteredExternalIssuer) {
            this.registrationStep = RegistrationStep.Validating;
            this.estimatedTime = undefined;
            this.statusDescription = 'Verifique seu e-mail.';
            this.trackingStep = IDENTIFICADA_STEP.pendenciaExterna;
        } else {
            this.registrationStep = RegistrationStep.Registration;
            this.estimatedTime = undefined;
            this.statusDescription = 'Termine seu cadastro.';
            this.trackingStep = IDENTIFICADA_STEP.cadastroPendente;
        }

        this.trackingLabel = IDENTIFICADA_STEP_LABEL[this.trackingStep];

        this.sendTracking(ActionEventsEnum.PAGE_LOADED, {
            'Product Area Origin': IDENTIFICADA_TRACKING.productAreaOrigin,
            'Status': IDENTIFICADA_TRACKING.status,
            'Scenario': this.santanderSuitabilityService.getClientSegment(),
            'Step': this.trackingStep,
            'Time Responsável': IDENTIFICADA_TRACKING.timeResponsavel,
        });

        this.store.dispatch({ type: AdvisorAction.getAdvisor });
    }

    public sendTracking(event: string, breakdowns: any) {
        this.store.dispatch({
            type: TrackingActions.trackEvents,
            payload: { type: event, events: breakdowns },
        });
    }

    public onCtaClick(element: string) {
        this.sendTracking(ActionEventsEnum.ELEMENT_CLICKED, {
            'Product Area Origin': IDENTIFICADA_TRACKING.productAreaOrigin,
            'Status': IDENTIFICADA_TRACKING.status,
            'Scenario': this.santanderSuitabilityService.getClientSegment(),
            'Step': this.trackingStep,
            'Label': this.trackingLabel,
            'Element': element,
            'Time Responsável': IDENTIFICADA_TRACKING.timeResponsavel,
        });
    }

    public ngAfterViewInit() {
        this.disposableSubscriptions.push(
            this.store
                .select((state) => {
                    return state.advisor.customerAdvisor
                })
                .pipe(skip(1))
                .subscribe((data) => {
                    this.hasAdvisor = !!data;
                })
        );
    }

    public scrollInterationClickButtom() {
        const body = $('html, body');
        const scrollTopElement = $('#doubts-section')
            .offset().top;

        body.animate(
            { scrollTop: scrollTopElement },
            700,
        );
    }
}
